import ExpandableTable from '@creditflowresearch/uilib/Table/ExpandableTable';
import { mapDealFields } from '@/creditflowresearch/ui/components/deals/DealListTable/helpers';
import cloneDeep from 'lodash/cloneDeep';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/table.module.scss';

export interface IGenericTableProps<T> {
  columns: any[],
  collection: T[],
  expandableRowContent?: React.ComponentType<any>,
  isFetching?: boolean,
  expandableComponent?: React.ReactNode,
  dataTest?: string,
  isRowsExpanded?: boolean,
  defaultExpandedRowIndexes?: number[],
  expandCollapseOnRowClick?: boolean,
  onRowClick?: (
    e: React.MouseEvent<HTMLTableRowElement>,
    params: { row: Record<string, any>, index: number, isExpanded: boolean },
  ) => void,
  RowWrapper?: React.ComponentType<any>,
}

export const GenericTable = <T extends any>({
  columns,
  collection,
  expandableRowContent,
  isFetching = false,
  expandableComponent,
  onRowClick,
  RowWrapper,
  dataTest = 'genericTable',
  isRowsExpanded = false,
  defaultExpandedRowIndexes = [],
  expandCollapseOnRowClick = true,
}: IGenericTableProps<T>) => {
  const mappedCollection = collection.map((item, index) => mapDealFields(cloneDeep(item), index, collection.length));

  return (
    <>
      <ExpandableTable
        className={ styles.dealsListTable }
        columns={ columns }
        collection={ mappedCollection }
        isRowsExpanded={ isRowsExpanded }
        isFetching={ isFetching }
        dataTest={ dataTest }
        expandableRowContent={ expandableRowContent }
        defaultExpandedRowIndexes={ defaultExpandedRowIndexes }
        expandCollapseOnRowClick={ expandCollapseOnRowClick }
        onRowClick={ onRowClick }
        RowWrapper={ RowWrapper }
      />
      { expandableComponent }
    </>
  );
};
